<template>  
  <b-modal
    v-if="vendor"
    v-model="showModal"
    centered
  >
    <template v-slot:modal-title>
      {{ vendor.benchmarked == "benching" ? 'Cancel Benchmarking' : 'Request Benchmarking' }}
    </template>
  
    <template v-slot:default>
      {{ vendor.benchmarked == "benching" ? 'Are you sure you want to cancel benchmarking?' : `Have Meet Virginia benchmark ${ vendor.vendor_name } against their competitors.` }}
    </template>
  
    <template v-slot:modal-footer>
      <b-btn
        variant="secondary"
        @click="closeModal"
      >
        Cancel
      </b-btn>
      <b-btn
        variant="primary"
        @click="handleConfirm(vendor)"
      >
        Confirm
      </b-btn>
    </template>
  </b-modal>
</template>
  
  <script>
  import UserClient from '@/api/UserClient';
  export default {
    props:{
      handleConfirm: {
        type: Function 
      }
    },
    data() {
      return {
        showModal: false,
        vendor: null,
        userClient: new UserClient(this.$http),
      };
    },
    methods: {
      closeModal() {
        this.showModal = false;
        this.vendor = null;
      },
      openModal(currentVendor) {
        this.vendor = currentVendor;
        this.showModal = true;
      }
    }
  };
  </script>
  